import { Customer } from '../../../models/customer.models';

export class GetCustomer {
  static type = '[Customer] Get';
}

export class ReloadCustomer {
  static type = '[Customer] Reload';
}

export class UpdateCustomer {
  static type = '[Customer] Update';

  constructor(readonly update: Partial<Customer>) {}
}

export class GetThirdPartyAccounts {
  static type = '[Customer] Get Third Party Accounts';
}
